import { render, staticRenderFns } from "./month_card.vue?vue&type=template&id=0faf2b4e&scoped=true&"
import script from "./month_card.vue?vue&type=script&lang=js&"
export * from "./month_card.vue?vue&type=script&lang=js&"
import style0 from "./month_card.vue?vue&type=style&index=0&id=0faf2b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf2b4e",
  null
  
)

export default component.exports